import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowRightIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileArrowRightIn"><Path d="M17.4141 16L15.4141 18H21V20H15.4141L17.4141 22L16 23.4141L11.5859 19L16 14.5859L17.4141 16Z" fill="currentColor"/><Path d="M12 10H20V15.7578L16 11.7578L8.75781 19L11.7578 22H4V2H12V10Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowRightIn;
